import { render, staticRenderFns } from "./ModalHistoryHold.vue?vue&type=template&id=0ca1d56e&"
import script from "./ModalHistoryHold.vue?vue&type=script&lang=js&"
export * from "./ModalHistoryHold.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports